"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinusIcon = void 0;
const react_1 = __importDefault(require("react"));
const MinusIcon = () => (react_1.default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.51251 9.00013C5.51251 8.61257 5.82669 8.2984 6.21424 8.2984H11.7842C12.1717 8.2984 12.4859 8.61257 12.4859 9.00013C12.4859 9.38768 12.1717 9.70185 11.7842 9.70185H6.21424C5.82669 9.70185 5.51251 9.38768 5.51251 9.00013Z", fill: "currentColor" })));
exports.MinusIcon = MinusIcon;
